import { React, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import AOS from "aos";
// import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import Button from "../Button";
import FormModal from '../../Components/FormModal';

// Soultion Card images
import Cardimg_1 from '../../images/Industries/micro-landing/Energy_Card_1.png'
import liaison_cardimg from '../../images/Industries/micro-landing/liaison_card.png'
import Tenent from '../../images/Industries/micro-landing/tenant_image.png'
import Landlord from '../../images/Industries/micro-landing/landlord_image.png'

// Retail Service images
import sales_icon from '../../images/Industries/micro-landing/retail-images/sales_icon.png'
import risk_icon from '../../images/Industries/micro-landing/retail-images/risk_icon.png'
import revenue_icon from '../../images/Industries/micro-landing/retail-images/revenue_icon.png'
import slider_1 from '../../images/Industries/micro-landing/retail-images/slider_1.jpg'
import slider_2 from '../../images/Industries/micro-landing/retail-images/slider_2.jpg'



function ServiceType() {

    // Modal State & Function
    const [modalToggle, setModalToggle] = useState(false);
    function toggle() {
        setModalToggle(!modalToggle);
    }

    const params = useParams();
    const path = params.micro_id;

    const [show, setShow] = useState(false);

    useEffect(() => {
        if (path === "retail") {
            setShow(true);
        }

    }, [])

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    // Solution Card
    const serviceCard = {

        logistics: {
            image_1: Cardimg_1,
            alt_1: "Card image",
            heading_1: "Industrial Real Estate",
            content_1: "Find the right land and location to set up your industry with confidence",
            button_1: "Send an enquiry",
            Link_1: "#",

            // Card 2
            image_2: liaison_cardimg,
            alt_2: "Card image",
            heading_2: "Liaison Services",
            content_2: " Approvals, permits, and compliance — handled seamlessly so you don’t lose time.",
            button_2: "Explore Our Services",
            Link_2: "#",
        },

        development: {
            image_1: Cardimg_1,
            alt_1: "Card image",
            heading_1: "For Developers - Maximise Returns",
            content_1: "Secure prime land parcels for your next project. We connect you with landlords open to Joint Ventures, ensuring you gain both location advantage and cost efficiency.",
            button_1: "Explore Opportunities",
            Link_1: "#",

            // Card 2
            image_2: liaison_cardimg,
            alt_2: "Card image",
            heading_2: "For Landowners - Partner for the Best Deal",
            content_2: " Looking for a trusted developer to unlock your land’s value? We structure Joint Ventures that balance equity, risk, and long-term returns — turning your land into a growth asset.",
            button_2: "Start a JV",
            Link_2: "#",
        },

        it: {
            image_1: Cardimg_1,
            alt_1: "Card image",
            heading_1: "Property fit",
            content_1: "Searching for a perfect property for your IT company?",
            button_1: "Find your Property",
            Link_1: "#",

            // Card 2
            image_2: liaison_cardimg,
            alt_2: "Card image",
            heading_2: "Liaison Services",
            content_2: "Worried about spending time in Government approvals?",
            button_2: "Explore Our Services",
            Link_2: "#",
        },

        retail: {
            image_1: Tenent,
            alt_1: "Card image",
            heading_1: "Tenent",
            content_1: "Unlisted and verified properties in thriving micro markets.",
            button_1: "Find your Space",
            Link_1: "#",

            // Card 2
            image_2: Landlord,
            alt_2: "Card image",
            heading_2: "Land Lord",
            content_2: "Find the right customer across national and international brands for your property.",
            button_2: "Maximize Your Property",
            Link_2: "#",
        },

        commercial: {
            image_1: Tenent,
            alt_1: "Card image",
            heading_1: "Tenent",
            content_1: "Unlisted and verified properties in thriving micro markets.",
            button_1: "Find your Space",
            Link_1: "#",

            // Card 2
            image_2: Landlord,
            alt_2: "Card image",
            heading_2: "Land Lord",
            content_2: "Find the right customer across national and international brands for your property.",
            button_2: "Maximize Your Property",
            Link_2: "#",
        },

        energy: {

            image_1: Cardimg_1,
            alt_1: "Liaison Card image",
            heading_1: "Land aggregation",
            content_1: " Strategic location anchoring and aggregation services for solar farms, wind projects, and green hydrogen plants — ensuring scale, efficiency, and future readiness.",
            button_1: "Explore Our Services",
            Link_1: "#",

            // Card 2
            image_2: liaison_cardimg,
            alt_2: "Liaison Card image",
            heading_2: "Liaison Services",
            content_2: "End-to-end liaison and approval support with government departments for all land-related clearances — simplifying compliance so your projects stay on track.",
            button_2: "Explore Our Services",
            Link_2: "#",
        },

        manufacturing: {

            image_1: Cardimg_1,
            alt_1: "Liaison Card image",
            heading_1: "Land aggregation",
            content_1: "Location anchoring and land aggregation services for wind and solar farms and green hydrogen energy plants",
            button_1: "Explore Our Services",
            Link_1: "#",

            // Card 2
            image_2: liaison_cardimg,
            alt_2: "Liaison Card image",
            heading_2: "Liaison Services",
            content_2: "Liaison & approval services from all government departments for all land related approvals.",
            button_2: "Explore Our Services",
            Link_2: "#",
        },
    }

    // Retail services
    const retail_Services = [
        {
            icon: sales_icon,
            heading: "Boost Sales",
            content: "Map territories and micro-markets to grow your retail footprint"
        },
        {
            icon: revenue_icon,
            heading: "Maximizing revenue",
            content: "Choose the right location with data-backed insights."
        },
        {
            icon: risk_icon,
            heading: "Managing risk",
            content: "Use demographic patterns to make smarter, safer decisions."
        },

    ]






    return (
        <>

            {/* Solution Cards for all paths */}

            <div className={path === "logistics" || path === "development" || path === "it" || path === "energy" || path === "retail" || path === "commercial" || path === "manufacturing" ? "max-w-[1090px] mx-auto my-[60px] md:my-[140px]" : "hidden"} id="solution-section">

                {/* Heading */}
                <h1 className='heading' data-aos="fade-up">Solutions for Every Need</h1>
                <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]' data-aos="fade-up" data-aos-duration="800"/>

                {/* Service card */}

                <div className="flex flex-wrap justify-between gap-10 my-[90px] px-8 sm:px-4">

                    <div className="max-w-[500px] h-fit pb-[40px] mx-auto bg-grey text-center" data-aos="fade-up">
                        <img src={serviceCard[path].image_1} alt={serviceCard[path].alt_1} />

                        <div className="max-w-[430px] mx-auto px-2 md:px-0">
                            <h1 className="font-noto text-[30px] font-bold mt-[44px] sm:text-[32px]">{serviceCard[path].heading_1}</h1>
                            <p className="font-alibaba text-[17px] text-[#5F5D5E] leading-[28px] mt-[20px] mb-[40px] px-1">{serviceCard[path].content_1}</p>
                        </div>

                        <Link to={serviceCard[path].Link_1} >
                            <Button
                                name={serviceCard[path].button_1}
                                design={"filled"}
                                action={"modal-open"}
                                modalfunction={toggle}
                            />
                        </Link>

                    </div>

                    {/* Second card */}

                    <div className="max-w-[500px] h-fit pb-[40px] mx-auto bg-grey text-center relative" data-aos="fade-up">
                        <img src={serviceCard[path].image_2} alt={serviceCard[path].alt_2} />

                        <div className="max-w-[430px] mx-auto px-2 md:px-0">
                            <h1 className="font-noto text-[30px] font-bold mt-[44px] sm:text-[32px]">{serviceCard[path].heading_2}</h1>
                            <p className="font-alibaba text-[17px] text-[#5F5D5E] leading-[28px] mt-[20px] mb-[40px]">{serviceCard[path].content_2}</p>
                        </div>

                        <Link to={serviceCard[path].Link_2} >
                            <Button
                                name={serviceCard[path].button_2}
                                design={"filled"}
                                action={"modal-open"}
                                modalfunction={toggle}
                            />
                        </Link>

                    </div>


                </div>

            </div>


            {/* Retail Services cards */}

            <div className={path === "retail" ? "max-w-full mx-auto sm:my-[140px]" : "hidden"}>

                {/* Heading */}
                <div className="max-w-[700px] mx-auto">
                    <h1 className='heading' data-aos="fade-up">Turn location choices into <br /> business advantages.</h1>
                    <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]'  data-aos="fade-up"/>
                    <p className="service-description max-w-[822px] mx-auto" data-aos="fade-up">With data, insights, and market intelligence, we help you grow sales, increase revenue, and reduce risk.</p>

                </div>

                {/* Services of retail */}

                <div className="max-w-[1230px] mx-auto flex flex-wrap justify-evenly gap-6 mt-[62px] px-4 lg:px-0">

                    {
                        retail_Services.map((items) => {

                            return (

                                <div className="w-[382px] h-fit mx-auto bg-grey p-[40px] sm:h-[376px]" data-aos="fade-up">
                                    <img className="w-[65px]" src={items.icon} alt="icons" />
                                    <h1 className="font-noto text-[26px] font-bold leading-[40px] mt-[20px] sm:mt-[38px] sm:text-[32px]">{items.heading}</h1>
                                    <p className="font-alibaba text-[#5F5D5E] text-[18px] leading-[30px] mt-[25px] sm:text-[20px]">{items.content}</p>
                                </div>

                            )
                        })}

                </div>


                {/* Retail Images Slider  */}

                <Swiper className="!w-full  mt-[60px] !sm:my-[150px]"
                    spaceBetween={30}
                    centeredSlides={true}
                    autoplay={{
                        delay: 2000,
                        disableOnInteraction: false,
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    navigation={true}
                    modules={[Autoplay, Pagination, Navigation]}
                >

                    <SwiperSlide>
                        <img className="w-full h-[450px] sm:h-[725px] object-cover " src={slider_1} alt="Retail_slider" />
                    </SwiperSlide>

                    <SwiperSlide>
                        <img className="w-full h-[450px] sm:h-[725px] object-cover " src={slider_2} alt="Retail_slider" />
                    </SwiperSlide>

                </Swiper>

            </div>

            <FormModal
                modal={modalToggle}
                active={toggle}
            />

        </>
    )
}

export default ServiceType